// Chip de elección única de la Cotización (plazo, nivel): el elegido va relleno en el color del texto.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function ChoiceChip({
    selected,
    onSelect,
    disabled,
    className,
    children,
}: {
    selected: boolean;
    onSelect: () => void;
    disabled?: boolean;
    className?: string;
    children: ReactNode;
}) {
    return (
        <button
            type="button"
            aria-pressed={selected}
            disabled={disabled}
            onClick={() => {
                if (!selected) onSelect();
            }}
            className={cn(
                'min-h-10 rounded-[10px] border px-4 text-[13px] transition-colors',
                selected
                    ? 'border-foreground bg-foreground font-semibold text-background'
                    : 'border-border bg-card font-medium hover:border-foreground/50',
                className,
            )}
        >
            {children}
        </button>
    );
}
